export const CARD_MEMBER = 'CARD_MEMBER';
export const CARD_SELECTOR = 'CARD_SELECTOR';
export const constants = {
  dateFormatter: '.',
};
export const THANK_YOU = 'THANK_YOU';
